export const stopWords = new Set([
  'the', 'a', 'an', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with',
  'by', 'from', 'as', 'is', 'was', 'are', 'were', 'been', 'be', 'have', 'has', 'had',
  'do', 'does', 'did', 'will', 'would', 'could', 'should', 'may', 'might', 'must',
  'i', 'you', 'he', 'she', 'it', 'we', 'they', 'me', 'him', 'her', 'us', 'them',
  'my', 'your', 'his', 'its', 'our', 'their', 'this', 'that', 'these', 'those',
  'what', 'which', 'who', 'whom', 'when', 'where', 'why', 'how', 'all', 'each',
  'very', 'just', 'also', 'so', 'than', 'too', 'more', 'most', 'some', 'any', 'no',
  'not', 'only', 'same', 'such', 'into', 'through', 'during', 'before', 'after',
  'above', 'below', 'between', 'under', 'again', 'further', 'then', 'once'
]);

export const positiveWords = new Set([
  'good', 'great', 'excellent', 'amazing', 'wonderful', 'fantastic', 'outstanding', 'superb',
  'love', 'like', 'happy', 'pleased', 'satisfied', 'delighted', 'impressed', 'enjoy',
  'best', 'perfect', 'awesome', 'brilliant', 'helpful', 'friendly', 'recommend', 'positive',
  'easy', 'fast', 'quick', 'efficient', 'reliable', 'quality', 'professional', 'clean',
  'beautiful', 'nice', 'pleasant', 'comfortable', 'convenient', 'valuable', 'useful', 'effective',
  'thank', 'thanks', 'appreciate', 'glad', 'excited', 'thrilled', 'incredible', 'exceptional'
]);

export const negativeWords = new Set([
  'bad', 'poor', 'terrible', 'awful', 'horrible', 'disappointing', 'disappointed', 'frustrated',
  'hate', 'dislike', 'unhappy', 'dissatisfied', 'annoyed', 'angry', 'upset', 'worst',
  'slow', 'difficult', 'hard', 'confusing', 'complicated', 'expensive', 'broken', 'failed',
  'problem', 'issue', 'bug', 'error', 'wrong', 'mistake', 'waste', 'useless',
  'rude', 'unprofessional', 'unreliable', 'terrible', 'never', 'boring', 'lacking', 'missing',
  'complaint', 'refund', 'cancel', 'worse', 'ridiculous', 'unacceptable', 'pathetic', 'mediocre'
]);

export const subjectiveWords = new Set([
  'think', 'believe', 'feel', 'opinion', 'seems', 'probably', 'maybe', 'perhaps',
  'personally', 'honestly', 'frankly', 'definitely', 'certainly', 'absolutely', 'totally',
  'love', 'hate', 'like', 'prefer', 'want', 'wish', 'hope', 'guess',
  'amazing', 'terrible', 'wonderful', 'awful', 'best', 'worst', 'beautiful', 'ugly'
]);

export const experientialWords = new Set([
  'felt', 'feel', 'feeling', 'experienced', 'experience', 'experiencing',
  'sensed', 'sense', 'sensing', 'perceived', 'perceive', 'perceiving',
  'noticed', 'notice', 'noticing', 'realized', 'realize', 'realizing',
  'understood', 'understand', 'understanding', 'discovered', 'discover',
  'saw', 'see', 'seeing', 'heard', 'hear', 'hearing',
  'touched', 'touch', 'touching', 'smelled', 'smell', 'tasted', 'taste',
  'remembered', 'remember', 'remembering', 'imagined', 'imagine', 'imagining',
  'wondered', 'wonder', 'wondering', 'thought', 'thinking',
  'lived', 'living', 'existed', 'existing', 'being', 'became', 'become'
]);

export const emotionWords = new Set([
  'happy', 'sad', 'angry', 'afraid', 'scared', 'anxious', 'worried', 'nervous',
  'excited', 'thrilled', 'joyful', 'peaceful', 'calm', 'relaxed', 'content',
  'frustrated', 'confused', 'overwhelmed', 'stressed', 'tired', 'exhausted',
  'hopeful', 'optimistic', 'pessimistic', 'hopeless', 'desperate', 'lonely',
  'loved', 'unloved', 'appreciated', 'ignored', 'rejected', 'accepted',
  'proud', 'ashamed', 'embarrassed', 'guilty', 'regretful', 'grateful',
  'curious', 'interested', 'bored', 'indifferent', 'passionate', 'inspired'
]);

export const temporalMarkers = new Set([
  'first', 'then', 'next', 'after', 'before', 'finally', 'eventually', 'suddenly',
  'meanwhile', 'later', 'earlier', 'previously', 'subsequently', 'immediately',
  'once', 'when', 'while', 'during', 'until', 'since', 'always', 'never',
  'sometimes', 'often', 'rarely', 'usually', 'yesterday', 'today', 'tomorrow',
  'ago', 'now', 'soon', 'recently', 'formerly', 'initially', 'ultimately'
]);

export const hedgingWords = new Set([
  'maybe', 'perhaps', 'possibly', 'probably', 'might', 'could', 'would',
  'seem', 'seems', 'seemed', 'appear', 'appears', 'appeared',
  'suggest', 'suggests', 'suggested', 'indicate', 'indicates', 'indicated',
  'somewhat', 'rather', 'quite', 'fairly', 'relatively', 'approximately',
  'tend', 'tends', 'tended', 'likely', 'unlikely', 'generally', 'typically',
  'usually', 'often', 'sometimes', 'occasionally', 'partly', 'partially'
]);

export const powerWords = new Set([
  'must', 'should', 'need', 'require', 'demand', 'insist', 'order', 'command',
  'control', 'manage', 'lead', 'direct', 'decide', 'determine', 'force',
  'allow', 'permit', 'authorize', 'empower', 'enable', 'prevent', 'prohibit',
  'important', 'essential', 'critical', 'vital', 'necessary', 'mandatory',
  'authority', 'power', 'influence', 'dominant', 'superior', 'inferior'
]);

export const agencyWords = new Set([
  'i', 'we', 'my', 'our', 'me', 'us', 'myself', 'ourselves',
  'chose', 'choose', 'decided', 'decide', 'wanted', 'want',
  'planned', 'plan', 'intended', 'intend', 'aimed', 'aim',
  'achieved', 'achieve', 'accomplished', 'accomplish', 'succeeded', 'succeed',
  'tried', 'try', 'attempted', 'attempt', 'managed', 'manage',
  'created', 'create', 'built', 'build', 'made', 'make', 'did', 'done'
]);

export const passiveIndicators = new Set([
  'was', 'were', 'been', 'being', 'got', 'gotten',
  'happened', 'occurred', 'arose', 'resulted', 'caused',
  'forced', 'made', 'required', 'expected', 'supposed',
  'told', 'asked', 'given', 'shown', 'taught', 'sent'
]);

export const defaultContentCategories = [
  { id: 'quality', name: 'Quality/Performance', keywords: ['quality', 'performance', 'reliable', 'efficient', 'effective', 'works', 'broken', 'fast', 'slow'] },
  { id: 'service', name: 'Customer Service', keywords: ['service', 'staff', 'support', 'help', 'friendly', 'rude', 'response', 'team', 'assistance'] },
  { id: 'value', name: 'Value/Pricing', keywords: ['price', 'value', 'cost', 'expensive', 'cheap', 'worth', 'money', 'affordable', 'budget'] },
  { id: 'experience', name: 'User Experience', keywords: ['easy', 'simple', 'difficult', 'confusing', 'intuitive', 'interface', 'design', 'use', 'navigate'] },
  { id: 'satisfaction', name: 'Satisfaction', keywords: ['happy', 'satisfied', 'disappointed', 'recommend', 'love', 'hate', 'great', 'terrible', 'pleased'] },
  { id: 'communication', name: 'Communication', keywords: ['communication', 'informed', 'updates', 'clear', 'confusing', 'responsive', 'email', 'call', 'contact'] },
  { id: 'time', name: 'Time/Speed', keywords: ['time', 'fast', 'slow', 'quick', 'wait', 'delay', 'prompt', 'immediate', 'hours', 'days'] },
  { id: 'trust', name: 'Trust/Reliability', keywords: ['trust', 'reliable', 'honest', 'transparent', 'dependable', 'consistent', 'safe', 'secure', 'credible'] }
];

export const narrativePhases = {
  orientation: {
    name: 'Orientation',
    description: 'Setting the scene (who, what, where, when)',
    markers: ['was', 'were', 'had', 'there', 'once', 'when', 'where', 'who', 'what', 'first', 'initially', 'began', 'started']
  },
  complication: {
    name: 'Complication',
    description: 'The problem or challenge',
    markers: ['but', 'however', 'suddenly', 'unfortunately', 'problem', 'issue', 'challenge', 'difficult', 'struggled', 'failed', 'wrong', 'trouble']
  },
  evaluation: {
    name: 'Evaluation',
    description: 'Reflection on events',
    markers: ['felt', 'thought', 'believed', 'realized', 'understood', 'important', 'meant', 'seemed', 'appeared', 'wondered']
  },
  resolution: {
    name: 'Resolution',
    description: 'How it was resolved',
    markers: ['finally', 'eventually', 'solved', 'fixed', 'resolved', 'managed', 'succeeded', 'achieved', 'overcame', 'worked']
  },
  coda: {
    name: 'Coda',
    description: 'Conclusion or lesson learned',
    markers: ['now', 'today', 'learned', 'lesson', 'realize', 'understand', 'never', 'always', 'since', 'from now', 'going forward']
  }
};

export const tokenize = (text) => {
  return text.toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .split(/\s+/)
    .filter(word => word.length > 2 && !stopWords.has(word));
};

export const tokenizeAll = (text) => {
  return text.toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .split(/\s+/)
    .filter(word => word.length > 0);
};

export const splitIntoSentences = (text) => {
  return text
    .split(/[.!?]+/)
    .map(s => s.trim())
    .filter(s => s.length > 0);
};

export const countWordMatches = (words, wordSet) => {
  return words.filter(w => wordSet.has(w.toLowerCase())).length;
};

export const calculateWordFrequency = (texts) => {
  const freq = {};
  texts.forEach(text => {
    const words = tokenize(text);
    words.forEach(word => {
      freq[word] = (freq[word] || 0) + 1;
    });
  });
  return freq;
};

export const findCoOccurrences = (texts, categories) => {
  const coOccurrence = {};
  
  texts.forEach(text => {
    const words = new Set(tokenizeAll(text));
    const presentCategories = categories.filter(cat => 
      cat.keywords.some(kw => words.has(kw))
    );
    
    for (let i = 0; i < presentCategories.length; i++) {
      for (let j = i + 1; j < presentCategories.length; j++) {
        const key = [presentCategories[i].id, presentCategories[j].id].sort().join('-');
        coOccurrence[key] = (coOccurrence[key] || 0) + 1;
      }
    }
  });
  
  return coOccurrence;
};

export const extractQuotesWithKeywords = (texts, keywords, maxQuotes = 5) => {
  const quotes = [];
  const keywordSet = new Set(keywords.map(k => k.toLowerCase()));
  
  for (const text of texts) {
    const words = tokenizeAll(text);
    const matchCount = words.filter(w => keywordSet.has(w)).length;
    if (matchCount > 0) {
      quotes.push({
        text: text.length > 200 ? text.substring(0, 200) + '...' : text,
        matchCount,
        matchedWords: words.filter(w => keywordSet.has(w))
      });
    }
  }
  
  return quotes
    .sort((a, b) => b.matchCount - a.matchCount)
    .slice(0, maxQuotes);
};

export const generateAPAInterpretation = (analysisType, results) => {
  const date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  let interpretation = '';
  
  switch (analysisType) {
    case 'content':
      interpretation = `Content analysis was conducted on ${results.totalResponses} text responses using a categorical coding framework with ${results.categoryCount} predefined categories. `;
      interpretation += `The analysis identified ${results.totalCoded} instances of category-relevant content. `;
      if (results.topCategory) {
        interpretation += `The most prevalent category was "${results.topCategory.name}" with ${results.topCategory.count} occurrences (${results.topCategory.percentage}% of coded content). `;
      }
      break;
    case 'narrative':
      interpretation = `Narrative analysis examined ${results.totalResponses} responses for structural elements and storytelling patterns. `;
      interpretation += `Temporal markers were identified in ${results.temporalPercentage}% of responses, indicating narrative structure. `;
      interpretation += `The predominant narrative phase was "${results.dominantPhase}" (${results.phasePercentage}%). `;
      break;
    case 'discourse':
      interpretation = `Discourse analysis explored language patterns across ${results.totalResponses} responses. `;
      interpretation += `Hedging language appeared in ${results.hedgingPercentage}% of text, while power-related terms occurred in ${results.powerPercentage}%. `;
      interpretation += `Agency indicators suggest ${results.agencyLevel} participant agency in the narratives. `;
      break;
    case 'grounded':
      interpretation = `Grounded theory coding identified ${results.codeCount} distinct codes across ${results.totalResponses} responses. `;
      interpretation += `These were organized into ${results.categoryCount} axial categories. `;
      interpretation += `Theoretical saturation indicators suggest ${results.saturationLevel} saturation of themes. `;
      break;
    case 'phenomenological':
      interpretation = `Phenomenological analysis of ${results.totalResponses} responses identified ${results.essenceCount} essence themes. `;
      interpretation += `Experiential language was present in ${results.experientialPercentage}% of responses. `;
      interpretation += `${results.emotionCount} distinct emotional expressions were captured. `;
      break;
    default:
      interpretation = 'Analysis completed.';
  }
  
  interpretation += `\n\nNote: This automated analysis provides initial insights and should be complemented with researcher interpretation for comprehensive qualitative understanding (Analysis date: ${date}).`;
  
  return interpretation;
};
